<template>
  <div class="page_content">
    <yqyHeader :isLightStyle="isHeaderLight" @showMask="showMask" @goPageBottom="goPageBottom"></yqyHeader>
    <yqyContent ref="content" @changeHeadStyle="changeHeadStyle"></yqyContent>
    <div class="kefu cursor">
      <div class="qrcode flex-eju-center">
        <div>微信扫码，添加您的专属咨询顾问</div>
        <div class="img_wrapper">
          <img src="@/assets/svg/kefu-qrcode.png" />
        </div>
      </div>
      <img class="img" src="@/assets/svg/客服.png" alt="" />
      <div class="kefu_btn">顾问咨询</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    yqyHeader: () => import("@/components/header.vue"),
    yqyContent: () => import("@/pages/home/index.vue"),
  },
  data() {
    return {
      isHeaderLight: true,
    };
  },
  created() {},
  methods: {
    showMask() {
      this.$refs.content.showMask();
    },
    goPageBottom() {
      this.$refs.content.goPageBottom();
    },
    changeHeadStyle(val) {
      this.isHeaderLight = val;
    },
  },
};
</script>

<style lang="less" scoped>
.page_content {
  width: 100%;
  height: 100%;
  position: relative;
  .kefu {
    position: fixed;
    right: 0;
    bottom: 83px;
    z-index: 10;
    &:hover {
      .qrcode {
        opacity: 1;
        z-index: 1;
        visibility: inherit;
      }
    }
    .qrcode {
      width: 260px;
      height: 300px;
      background: #ffffff;
      border-radius: 12px;
      font-weight: 500;
      font-size: 14px;
      line-height: 40px;
      color: #212538;
      text-align: center;
      padding: 10px;
      box-sizing: border-box;
      position: absolute;
      right: 80px;
      bottom: 96px;
      flex-direction: column;
      z-index: -1;
      visibility: hidden;
      opacity: 0;
      transition: all .3s;
      box-shadow: 0 0px 20px 0px rgba(34, 34, 34, .1);
    }
    .img_wrapper {
      width: 200px;
      height: 200px;
      background: #ffffff;
      border: 1px solid rgba(34, 34, 34, 0.1);
      box-sizing: border-box;
      border-radius: 8px;
      padding: 8px;
      box-sizing: border-box;
      margin-top: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .img {
      width: 104px;
      height: 104px;
      position: relative;
      right: 16px;
      bottom: -4px;
    }
    .kefu_btn {
      width: 108px;
      height: 28px;
      font-size: 14px;
      color: #fff;
      text-align: center;
      line-height: 28px;
      border-radius: 16px 0 0 16px;
      background: linear-gradient(270deg, #007aff 0%, #00d085 100%), #007aff;
    }
  }
}
</style>
